import { MODEL_TYPE } from "../utils/enums";
export const routeEstimationModel = {
  totalDistance: 0,
  totalTime: 0,
  segments: [],
  modelType: MODEL_TYPE.routeEstimation
};
